export default __webpack_public_path__ + "static/media/signout.c7094308.svg";